import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem?.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";
import { riskCategoryTableColumns } from "assets/properties/properties";
import { riskCategoryMarketLtvTableColumns } from "assets/properties/properties";
import { riskCategoryDpdTableColumns } from "assets/properties/properties";
import axios from "axios";
import ConfirmationModal from "views/components/ConfirmationModal";
import { riskCategoryAndWeightageTableColumns } from "assets/properties/properties";
import { riskCategoryWeightageTableColumns } from "assets/properties/properties";
import { sortByProperty } from "utils/Utils";
import { riskCategoryAuditLtv } from "assets/properties/properties";
import { riskCategoryDpd } from "assets/properties/properties";
import { riskCategoryMarketLtv } from "assets/properties/properties";
import { actionText } from "assets/properties/properties";
const RiskCategoryMaster = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData1, setSelectedTableData1] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [selectedTableDataMarket, setSelectedTableDataMarket] = useState([]);
  const [selectedTableDataDpd, setSelectedTableDataDpd] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteSchemeId, setDeleteSchemeId] = useState("");
  const [tableData, setTableData] = useState([]);
  const [weightageTextDelete, setWeightageTextDelete] = useState(false);
  // submit create function
  const handleCreateRiskCategory = () => {
    navigate(`/coreservice/riskCategory-create`);
  };
  const handleUpdateRiskWeightage = () => {
    navigate(`/coreservice/riskWeightage-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    findRiskCategoryData();
    GetData();
  }, []);
  const findRiskCategoryData = async () => {
    const result = await apiHandler({
      url: endpoint.RISK_WEIGHTAGE_SCORE_FIND_ALL,
      authToken: authToken,
    });
    parseIndicatorDataAuctionLtv(result?.data);
  };

  const parseIndicatorDataAuctionLtv = (data) => {
    let reportData = [];

    data?.forEach((role) => {
      let row = {
        base: role?.riskType?.replace(/_/g, " "),
        weightage: role?.weightage || 0,
        viewCode: role?.id,
      };
      reportData?.push(row);
    });

    setSelectedTableData(reportData);
  };
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.RISK_CATEGORY_FIND_ALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      const data = result?.data;
      const auditedLtvArray = sortByProperty(data, riskCategoryAuditLtv?.minAuditedLtv, [riskCategoryAuditLtv?.minAuditedLtv, riskCategoryAuditLtv?.maxAuditedLtv,riskCategoryAuditLtv?.auditLtvScore]);

      const marketLtvArray = sortByProperty(data, riskCategoryMarketLtv?.minMarketLtv, [riskCategoryMarketLtv?.minMarketLtv, riskCategoryMarketLtv?.maxMarketLtv, riskCategoryMarketLtv?.marketLtvScore]);

      
      const dpdArray = sortByProperty(data, riskCategoryDpd?.minDpd, [riskCategoryDpd?.minDpd, riskCategoryDpd?.maxDpd, riskCategoryDpd?.dpdScore]);

      parseIndicatorDataLtv(auditedLtvArray, marketLtvArray, dpdArray);
    }
  };
  const parseIndicatorDataLtv = (auditedLtvArray, marketLtvArray, dpdArray) => {
    let reportData = [];

    // Audited LTV
    auditedLtvArray?.forEach((role, index) => {
      let row = {
        base: index === 0 && riskCategoryAuditLtv?.auditLtvName,
        min: role?.minAuditedLtv || 0,
        max: role?.maxAuditedLtv || 0,
        score: role?.auditLtvScore || 0,
        action: getIcons(role?.id, actionText?.edit, actionText?.delete,"",role),
        viewCode: role?.id,
      };
      reportData?.push(row);
    });

    // // Market LTV
    marketLtvArray?.forEach((role, index) => {
      let row = {
        base: index === 0 && riskCategoryMarketLtv?.marketLtvName,
        min: role?.minMarketLtv || 0,
        max: role?.maxMarketLtv || 0,
        score: role?.marketLtvScore || 0,
        action: getIcons(role?.id, actionText?.edit, actionText?.delete, "",role),
        viewCode: role?.id,
      };
      reportData?.push(row);
    });

    // // DPD
    dpdArray?.forEach((role, index) => {
      let row = {
        base: index === 0 && riskCategoryDpd?.dpdName,
        min: role?.minDpd || 0,
        max: role?.maxDpd || 0,
        score: role?.dpdScore || 0,
        action: getIcons(role?.id, actionText?.edit, actionText?.delete, "",role),
        viewCode: role?.id,
      };
      reportData?.push(row);
    });
    setSelectedTableData1(reportData);
  };

  // icons function
  const getIcons = (id, editText, deleteText, weightageText,data) => {
    return (
      <>
        {editText && (
          <IconButton
            aria-label="Edit id"
            onClick={(e) => {
              e.stopPropagation();
              onClickUpdateData(id);
            }}
          >
            <EditIcon />
          </IconButton>
        )}
        {deleteText && (
          <IconButton
            aria-label="Delete Scheme"
            onClick={(e) => {
              e.stopPropagation();
              onClickDeleteData(id, weightageText, data);
            }}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </>
    );
  };
  // update function
  const onClickUpdateData = (id) => {
    navigate(`/coreservice/riskCategory-create/` + id);
  };
  const onClickDeleteData = (id, weightageText, data) => {
    setTableData([data]);
    setConfirmationModalHeader("Risk Category");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteSchemeId(id);
    setWeightageTextDelete(weightageText ? true : false);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteSchemeId("");
  };
  const handlePositiveResponse = async () => {
    const schemeId = deleteSchemeId;
    handleNegativeResponse();
    setCallInProgress(true);
  
    try {
      let URL;
      if (weightageTextDelete) {
        URL = `${endpoint.BASE_URL_STAGING}/${endpoint.RISK_WEIGHTAGE_SCORE_DELETE}${schemeId}`;
      } else {
        URL = `${endpoint.BASE_URL_STAGING}/${endpoint.RISK_CATEGORY_DELETE}${schemeId}`;
      }
  
      const res = await axios.delete(URL, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
  
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
      } else {
        const message = weightageTextDelete
          ? "Delete Risk Category Weightage is successful"
          : "Delete Risk Category is successful";
        toastUpdate("Success", message, true);
        GetData();
        findRiskCategoryData();
      }
    } catch (error) {
      // Handle error scenario
      toastUpdate("Error", "An error occurred while deleting.", true);
    } finally {
      setCallInProgress(false);
    }
  };

  // view function
  const onClickViewData = (code, type) => {
    navigate(`/coreservice/riskCategory-createView/` + code);
  };
  const onClickViewWeightageData = (code, type) => {
    navigate(`/coreservice/riskWeightage-createView/` + code);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Risk Category Master"
          button1="Create Risk Category"
          button1click={handleCreateRiskCategory}
          button2="Updated Risk Weightage"
          button2click={handleUpdateRiskWeightage}
        />
      </GridItem>
      <GridItem
        xs={12}
        sm={12}
        md={12}
        style={{ display: `flex`}}
      >
        <div style={{width:"40%"}}>
        <ColumnGroupingTable
          columns={riskCategoryWeightageTableColumns}
          rows={selectedTableData}
          onClickViewData={onClickViewWeightageData}
          clickable
          noPagination
          
        />
        </div>
        <div style={{width:"60%"}}>
        <ColumnGroupingTable
          columns={riskCategoryAndWeightageTableColumns}
          rows={selectedTableData1}
          onClickViewData={onClickViewData}
          clickable
          noPagination
          rowPerPageData={30}
        />
        </div>
      </GridItem>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
        tableData={tableData}
      />
    </GridContainer>
  );
};

export default RiskCategoryMaster;
